import { regex } from "../utils/regex";
import HelperNumber from "./HelperNumber";

const getFormErrorMessage = (form: any, errors: any) => {
  return errors.map((e: any) => `${form[e.field]?.description}: ${e.value}`).join(";   ");
}

function setDateToInput(date: string) {
  const today = new Date(date);
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  return `${year}-${format2Character(month)}-${format2Character(day)}`;
}

function format2Character(value: number) {
  return `${value < 10 ? `0${value}` : value}`;
}

const setPhoneBrMask = (value?: string) => {
  if(!value)
    return '';
  
  const cleanedValue = HelperNumber.justNumber(value ?? '');
  return cleanedValue.length > 10
    ? cleanedValue
      .replace(regex.subGrupWith2DigitsRegex, '($1) $2')
      .replace(regex.subGrupWith5DigitsRegex, '$1-$2')
    : cleanedValue
      .replace(regex.subGrupWith2DigitsRegex, '($1) $2')
      .replace(regex.subGrupWith4DigitsRegex, '$1-$2')
}

const setCompletePhoneBrMask = (value?: string) => {
  if (!value)
    return '';

  return value.replace(regex.notDigitRegex, '')
    .replace(regex.phoneBrRegex,
      (fullMatch, country, ddd, prefixTel, suffixTel) => {
        if (country)
          return `+${country} (${ddd}) ${prefixTel}-${suffixTel}`;
        if (ddd)
          return `(${ddd}) ${prefixTel}-${suffixTel}`;
        if (prefixTel && suffixTel)
          return `${prefixTel}-${suffixTel}`;
        return value;
      }
    );
}

const setCpfMask = (value: string) => {
  return value
    .replace(regex.notDigitRegex, '')
    .replace(regex.subGrupWith3DigitsRegex, '$1.$2')
    .replace(regex.subGrupWith3DigitsRegex, '$1.$2')
    .replace(regex.subGrupWith3DigitsRegex, '$1-$2')
}

const setDocumentBrMask = (value?: string) => {
  if (!value)
    return '';

  const cleanedValue = HelperNumber.justNumber(value);
  if( cleanedValue.length < 11) {
    return cleanedValue
  }
  if (cleanedValue.length === 11) {
    return cleanedValue
      .replace(regex.subGrupWith3DigitsRegex, '$1.$2')
      .replace(regex.subGrupWith3DigitsRegex, '$1.$2')
      .replace(regex.subGrupWith3DigitsRegex, '$1-$2')
  } else {
    return cleanedValue.replace(regex.cnpjRegex, "$1.$2.$3/$4-$5");
  }
}

function transformToFormData(obj: any): FormData {
  const formData = new FormData();

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    if (value == null) {
      return;
    }

    // Array
    if (Array.isArray(value)) {
      value.forEach((item, index) => {

        // Array de objetos
        if (typeof item === 'object' && item !== null) {
          Object.keys(item).forEach((property) => {
            formData.append(
              `${key}[${index}].${property}`,
              String(item[property])
            );
          });
        } else {
          // Array de valores simples
          formData.append(`${key}[${index}]`, String(item));
        }
      });

      return;
    }

    // Campos normais
    let valueForm = String(value);

    if (
      key === 'cellPhone' ||
      key === 'zipcode' ||
      key === 'document'
    ) {
      valueForm = valueForm.replace(regex.notDigitRegex, '');
    }

    formData.append(key, valueForm);
  });

  return formData;
}


function transformToFormDataFile(obj: any): FormData {
  const formData = new FormData();

  // Adiciona campos regulares
  Object.keys(obj).forEach((key) => {
    if (key !== 'lightBills' && obj[key] != null) {
      var valueForm = String(obj[key]);
      if(key === 'cellPhone' || key === 'zipcode'|| key === 'document'){
        valueForm = valueForm.replace(regex.notDigitRegex, '');
      }
      formData.append(key, valueForm);
    }
  });

  // Adiciona arquivos
  if (obj.lightBills) {
    if (obj.lightBills instanceof FileList) {
      // Se for FileList (do estado)
      Array.from(obj.lightBills).forEach((file: any) => {
        formData.append('lightBills', file);
      });
    } else if (Array.isArray(obj.lightBills)) {
      // Se for array (alternativo)
      obj.lightBills.forEach((file: File) => {
        formData.append('lightBills', file);
      });
    }
  }

  return formData;
}

function setMoneyMask(value: string) {
  let cleanedValue = value?.replace(regex.notDigitRegex, "");

  if (cleanedValue.length === 0) {
    return "";
  }
  if(cleanedValue.length > 1) {
    cleanedValue = cleanedValue.replace(/^0+/, '')
  }

  return "R$ " + cleanedValue
    .replace(/(\d+)(\d{2})$/, "$1,$2")
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
}

function setCepMask(value?: string) {
  if(!value)
    return '';
  return value.replace(regex.notDigitRegex, "")
    .replace(/^(\d{5})(\d{3})$/, "$1-$2");
}

const HelperForm = {
  getFormErrorMessage,
  setPhoneBrMask,
  setCompletePhoneBrMask,
  setDocumentBrMask,
  setCepMask,
  setCpfMask,
  setMoneyMask,
  setDateToInput,
  transformToFormData,
  transformToFormDataFile
}

export default HelperForm;
